import Analytics, { DEFAULT_ANALYTICS_CONTEXT_VALUE } from "@swiggy-private/analytics";
import { AnalyticsConfig } from "@swiggy-private/analytics/dist/interfaces";

// constants
export const ANALYTICS_HOST = "https://analytics.swiggy.com";

const isWebview = () => {
    return Boolean(
        typeof window !== "undefined" && (window.AndroidBridge || window.webkit?.messageHandlers?.nativeRequest),
    );
};

export const getAnalyticsConfigParams = (
    headers?: Record<string, string | undefined> | void,
): AnalyticsConfig | undefined => {
    /**
     * Some pages will open in web browser instead of webview and we want analytics events there.
     * So passing empty values for userInfo with proper analytics host
     */
    if (!isWebview()) {
        return {
            apiHost: ANALYTICS_HOST,
            userInfo: {
                deviceId: "-",
                sid: "-",
                tid: "-",
                userId: "-",
            },
            userLocation: { lat: "", lng: "" },
            platform: "-",
            appVersionCode: "-",
        };
    }

    if (!headers) {
        return;
    }

    return {
        apiHost: ANALYTICS_HOST,
        userInfo: {
            deviceId: headers.deviceId || "-",
            sid: headers.sid || "-",
            tid: headers.tid || "-",
            userId: headers.userId || "-",
        },
        userLocation: { lat: headers.lat || "", lng: headers.lng || "" },
        platform: headers.analyticsPlatform || "-",
        appVersionCode: headers["version-code"] || "-",
    };
};

export const getAnalyticsContextValue = (headers?: Record<string, string | undefined> | void) => {
    const analyticsConfig = getAnalyticsConfigParams(headers);
    const analytics = (analyticsConfig && new Analytics(analyticsConfig)) || DEFAULT_ANALYTICS_CONTEXT_VALUE;
    return analytics;
};
